import {NotificationManager} from 'react-notifications';
import {hashHistory} from 'react-router';
import store from 'store';

export default (error) => {
  var err = '';
  if (error.response !== '') {
    err = JSON.parse(error.response);
  }
  switch (error.status) {
    case 400:
      NotificationManager.warning(err.message || err.error_description);
      break;
    case 401:
      NotificationManager.warning('You are not authorized!');
      store.remove('userRf1');
      hashHistory.push('/login');
      break;
    case 500:
      NotificationManager.error('An error occurred, please contact support@rifird.com');
      break;
    case 0:
      NotificationManager.error('Check your internet connection');
      break;
    default:
      NotificationManager.error('An error occurred, please contact support@rifird.com');
      break;
  }
}


/** WEBPACK FOOTER **
 ** ./src/helpers/ErrorHandler.js
 **/